import React, { useEffect, useRef, useState } from "react";
import Button from "../../Buttons/Button";
import NewTab from "../../DynamicTabs/NewTab";
import DrawerAdv from "../../Modal/DrawerAdv";
import SearchCard from "../../SearchCard";
import GlobalSearchBar from "../../GlobalSearch/GlobalSearchBar";
import { globalSearchApi } from "../../../redux/slices/bdmjobs/bdmjobsApi";

const GlobalSearchDrawer = ({ isOpen, onClose }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState("All");
  const [activeTab, setActiveTab] = useState("search_applicant");
  const [candidates, setCandidates] = useState([]);
  const [jobPostings, setJobPostings] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceTimerRef = useRef(null);
  const pendingNextPageRef = useRef(false);
  const autoSwitchedRef = useRef(false);
  const [pageByTab, setPageByTab] = useState({
    search_applicant: 1,
    job_postings: 1,
  });
  const currentPage = pageByTab[activeTab];

  const [counts, setCounts] = useState({
    applicants: 0,
    jobs: 0,
  });

  useEffect(() => {
    switch (selectedOption) {
      case "Applicants":
        setActiveTab("search_applicant");
        break;

      case "Job Postings":
        setActiveTab("job_postings");
        break;

      case "All":
      default:
        setActiveTab("search_applicant");
        break;
    }
    setPageByTab({
      search_applicant: 1,
      job_postings: 1,
    });
  }, [selectedOption]);

  const SearchMenus = [
    {
      title: "Applicants",
      page: (
        <SearchCard searchQuery={searchQuery} searchType="search_applicant" data={candidates}
        loading={loading} onClose={onClose}/>
      ),
      type: "main",
      id: "search_applicant",
      value: `${counts?.candidates || 0}`,
    },
    {
      title: "Job Postings",
      page: (
        <SearchCard
          searchQuery={searchQuery}
          searchType="job_postings"
          isJobPostingView={true}
          data={jobPostings}
          loading={loading}
          onClose={onClose}
        />
      ),
      type: "main",
      id: "job_postings",
      value: `${counts?.jobs || 0}`,
    },
  ];
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const toggleDropdown = () => {
    setIsOpenDropdown(!isOpenDropdown);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);

    if (option === "Applicants") {
      setActiveTab("search_applicant");
    } else if (option === "Job Postings") {
      setActiveTab("job_postings");
    } else {
      setActiveTab("search_applicant");
    }
  };

  const filteredSearchMenus = SearchMenus.filter((menu) => {
    if (selectedOption === "All") return true;
    if (selectedOption === "Applicants" && menu.title === "Applicants")
      return true;
    if (selectedOption === "Job Postings" && menu.title === "Job Postings")
      return true;
    return false;
  });

  const getSearchType = () => {
    if (selectedOption === "Applicants") return ["candidates"];
    if (selectedOption === "Job Postings") return ["jobpostings"];
    return ["candidates", "jobpostings"];
  };

  useEffect(() => {
    if (!searchQuery) return;

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      fetchGlobalSearch();
    }, 400);

    return () => clearTimeout(debounceTimerRef.current);
  }, [searchQuery, activeTab, pageByTab]);

  const fetchGlobalSearch = async () => {
    try {
      setLoading(true);

      const params = {
        coll: "Candidate",
        // fil: JSON.stringify({uiid: {type: "AG_GLOBAL_SEARCH",value: searchQuery,searchType: getSearchType()}}),
        fil: JSON.stringify({uiid: {type: "AG_GLOBAL_SEARCH",value: searchQuery,moduleType: getSearchType()}}),
        useAggregate: true,
        queryMode: "AG_GLOBAL_SEARCH",
        pg: currentPage,
        lim: 10,
      };

      const res = await globalSearchApi(params);
      const data = res?.data?.data || {};

      // setCandidates(data.candidates || []);
      // setJobPostings(data.jobPostings || []);
      if (activeTab === "search_applicant") {
        setCandidates((prev) =>
          currentPage === 1
            ? data?.candidates || []
            : [...prev, ...(data?.candidates || [])]
        );
      }
      if (activeTab === "job_postings") {
        setJobPostings((prev) =>
          currentPage === 1
            ? data?.jobPostings || []
            : [...prev, ...(data?.jobPostings || [])]
        );
      }
      setCounts({
        candidates: data?.candidatesCount || 0,
        jobs: data?.jobPostingsCount || 0,
      });
      if (
        !autoSwitchedRef.current &&
        activeTab === "search_applicant" &&
        data?.candidatesCount === 0 &&
        data?.jobPostingsCount > 0 && 
        selectedOption === "All"
      ) {
        autoSwitchedRef.current = true;
        setActiveTab("job_postings");
      }
    } catch (err) {
      console.error("Global search failed", err);
    } finally {
      setLoading(false);
      pendingNextPageRef.current = false;
    }
  };

  useEffect(() => {
    if (!isOpen) {
      // reset everything when drawer closes
      setSearchQuery("");
      setCandidates([]);
      setJobPostings([]);
      setCounts({
        applicants: 0,
        jobs: 0,
      });
      setActiveTab("search_applicant");
      setPageByTab({
        search_applicant: 1,
        job_postings: 1,
      });
      setSelectedOption("All")

      // clear debounce timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = null;
      }
      autoSwitchedRef.current = false;
    }
  }, [isOpen]);

  useEffect(() => {
    if (!searchQuery) return;

    setPageByTab({
      search_applicant: 1,
      job_postings: 1,
    });
  }, [searchQuery]);

const currentData =
  activeTab === "search_applicant" ? candidates : jobPostings;

const currentCount =
  activeTab === "search_applicant"
    ? counts.candidates
    : counts.jobs;
const shouldShowLoadMore =
  currentData.length > 0 &&
  currentData.length < currentCount &&
  !loading;


  useEffect(() => {
    if (!searchQuery) return;

    setPageByTab((prev) => ({
      ...prev,
      [activeTab]: 1,
    }));
  }, [activeTab]);

  useEffect(() => {
    if (searchQuery.trim() !== "") return;

    setCandidates([]);
    setJobPostings([]);

    setCounts({
      candidates: 0,
      jobs: 0,
    });

    setPageByTab({
      search_applicant: 1,
      job_postings: 1,
    });

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }
  }, [searchQuery]);

  return (
    <DrawerAdv
      position="bottom"
      isOpen={isOpen}
      onClose={onClose}
      // showCloseButton={false}
      // closeOnOutsideClick
      height="h-[90%]"
    >
      <div className="flex flex-col flex-1 overflow-hidden">
        <div className="flex items-center justify-center gap-3 mx-auto">
          <GlobalSearchBar
            value={searchQuery}
            onChange={setSearchQuery}
            selectedOption={selectedOption}
            onOptionChange={handleOptionClick}
          />
        </div>

        <div className="flex flex-col gap-5 overflow-auto mt-3">
          <div className="grid grid-cols-1">
            <NewTab
              tabs={filteredSearchMenus}
              color="black"
              variant="text"
              activeVariant="text"
              mode="basic"
              tabId="search-details"
              defaultTab={filteredSearchMenus.findIndex(
                (tab) => tab.id === activeTab
              )}
              key={activeTab}
              onTabChange={(index) => {
                const tab = filteredSearchMenus[index];
                if (tab) {
                  setActiveTab(tab.id);
                  // setSelectedOption(tab.title);
                }
              }}
            />
          </div>

          {shouldShowLoadMore && (
            <div className="flex justify-center gap-4">
              <Button
                // title="Load More Applicants" 
                title={loading ? "Loading..." : "Load More Applicants"}
                disabled={loading}
                onClick={() => {
                  if (pendingNextPageRef.current) return;

                  pendingNextPageRef.current = true;
                  setPageByTab((prev) => ({
                    ...prev,
                    [activeTab]: prev[activeTab] + 1,
                  }))
                }
                }
              />
            </div>
          )}
        </div>
      </div>
    </DrawerAdv>
  );
};

export default GlobalSearchDrawer;
